import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Lightbulb } from "lucide-react";
import { PatternStatus, PatternFindingList } from "@/components/insights/PatternParts";

function ClientFindings({ list, narrative, loading, aiOff }) {
  if (loading) return null;
  return (
    <>
      {narrative && <p className="text-sm text-stone-800 leading-relaxed bg-amber-50 rounded-2xl p-4 border border-amber-100" data-testid="pattern-narrative">{narrative}</p>}
      {aiOff && <p className="text-xs text-stone-500" data-testid="pattern-ai-off">AI summaries are off by your choice — here are the plain findings.</p>}
      <PatternFindingList list={list} className={narrative || aiOff ? "mt-3" : ""} />
    </>
  );
}

function ClinicianFindings({ list, narrative, loading }) {
  if (loading) return null;
  return (
    <>
      <PatternFindingList list={list} />
      {narrative && <p className="text-xs text-stone-500 mt-3 italic" data-testid="pattern-client-copy">Client sees: “{narrative}”</p>}
    </>
  );
}

export function PatternInsights({ clientId, forClinician = false }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setData(null);
    const url = forClinician ? `/clinician/client/${clientId}/patterns` : "/insights/patterns";
    api.get(url).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [clientId, forClinician]);

  const list = (forClinician ? data?.findings : data?.positive) || [];
  const narrative = loading ? "" : data?.narrative || "";

  return (
    <div className="warm-card p-6" data-testid="pattern-insights">
      <div className="flex items-center gap-2 mb-3">
        <Lightbulb className="w-5 h-5 text-amber-700" />
        <h3 className="font-display text-lg font-bold text-stone-900">{forClinician ? "Habit ↔ wellbeing patterns" : "Patterns we're noticing"}</h3>
      </div>
      <PatternStatus loading={loading} data={data} list={list} />
      {forClinician && data?.ai_off && !loading && (
        <p className="text-xs text-rose-800 bg-rose-50 border border-rose-100 rounded-xl px-3 py-2 mb-3" data-testid="pattern-ai-off-clinician">AI is off for this member at their request — showing the non-AI findings.</p>
      )}
      {forClinician ? (
        <ClinicianFindings list={list} narrative={narrative} loading={loading} />
      ) : (
        <ClientFindings list={list} narrative={narrative} loading={loading} aiOff={!!data?.ai_off} />
      )}
    </div>
  );
}
